import { BehaviorSubject, of, switchMap, take } from 'rxjs';
import { ViewStatus } from '../../enums';
import { Command } from './command';

export class Invoker {
  private before?: Command;
  private actual?: Command;
  private after?: Command;
  private readonly statusSubject$ = new BehaviorSubject<ViewStatus>(
    ViewStatus.Init,
  );
  status$ = this.statusSubject$.asObservable();

  setBefore(command?: Command): void {
    this.before = command;
  }

  setActual(command: Command): void {
    this.actual = command;
  }

  setAfter(command?: Command): void {
    this.after = command;
  }

  execute(): void {
    this.statusSubject$.next(ViewStatus.Loading);
    (this.before?.execute$ ? this.before.execute$() : of(true))
      .pipe(
        switchMap((canExecuteActual) => {
          if (!canExecuteActual || !this.actual) {
            this.statusSubject$.next(ViewStatus.Resolved);
            return of(false);
          }
          return this.actual.execute$().pipe(
            switchMap((canExecuteAfter) => {
              if (!canExecuteAfter || !this.after) return of(false);
              return this.after.execute$().pipe(switchMap(() => of(false)));
            }),
          );
        }),
        take(1),
      )
      .subscribe({
        next: () => this.statusSubject$.next(ViewStatus.Resolved),
        error: () => this.statusSubject$.next(ViewStatus.Rejected),
      });
  }
}
